module.exports = __webpack_public_path__ + "static/media/Slide-2.7a77454a.png";